import Form from './Form';
export default Form;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/form/index.js
// module id = 783
// module chunks = 0